import { Tooltip, Accordion } from '@design-systems/canvas-ui'
import Icon, { InfoIcon } from '@design-systems/react-icons'
import VettingTimeline from './VettingTimeline'
import { getRfiTagValues } from '../../common/common'

const VettingTimelineView = (props) => {
  return (
    <Accordion
      className="hc8-pv-none vetting-timeline-accordion"
      spacing="none"
      header=""
      headerSlot={
        <div className="vetting-timeline-header-slot">
          <VettingTimeline
            vettingType={props.timeline?.vettingType}
            auditTrail={props.timeline?.auditTrail}
            supplierId={props.timeline?.supplierId}
            locationId={props.timeline?.locationId}
            manufacturingTypeId={props.timeline?.manufacturingTypeId}
            index={props.timeline?.index}
          />
        </div>
      }
    >
      <div className="vetting-next-move">
        <div className="vetting-next-move-heading">
          <span className="vetting-next-move-title">Next Move</span>
          <Tooltip
            key="tt-header-info"
            content={getRfiTagValues('vetting')['nextMoveInstruction']}
            location="right"
          >
            <Icon
              className="vetting-next-move-info-icon"
              svg={InfoIcon}
              aria-label="Next move information"
            />
          </Tooltip>
        </div>

        <div className="vetting-next-move-content">
          {props.timeline?.whatNext?.map((nextMove, index) => (
            <div
              className="vetting-next-move-item"
              key={`${index}-${nextMove}`}
              dangerouslySetInnerHTML={{ __html: nextMove }}
            />
          ))}
        </div>
      </div>
    </Accordion>
  )
}

export default VettingTimelineView
